// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mfa-challenge {
  padding: calc(2rem);
  background-color: #fff;
  border-radius: 0.25rem;
}

.mfa-challenge__back {
    display: inline-block;
    margin-bottom: calc(1.5rem);
  }

.mfa-challenge h1 {
    margin-bottom: calc(.5rem);
  }

@media (width <= 640px) {

.mfa-challenge {
    padding: calc(1.25rem)
}

    .mfa-challenge .button {
      width: 100%;
    }
  }

.mfa-challenge ftr-untyped-form {
    display: flex;
  }

.mfa-challenge ftr-untyped-form .form {
      display: flex;
      flex-basis: 50%;
      flex-direction: column;
    }

@media (width <= 640px) {

.mfa-challenge ftr-untyped-form .form {
        flex-basis: 100%
    }
      }

.mfa-challenge ftr-untyped-form .form__footer {
      flex-direction: row;
      margin-top: calc(1.5rem);
    }

@media (width <= 640px) {
        .mfa-challenge ftr-untyped-form .form__footer .form__footer__submit {
          width: 100%;
        }
      }

.mfa-challenge ftr-untyped-form .form__footer a {
        margin: 0;
      }

.mfa-challenge__text {
    margin-bottom: calc(1.5rem);
  }

.mfa-challenge__link {
    margin-top: calc(1.5rem);
  }

.mfa-challenge .row {
    margin-left: 0;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
